import * as React from 'react';
import { withRouter } from 'react-router-dom';

import classNames from 'classnames';

import { IScrollSliderProps } from './types';

import * as s from './ScrollCarousel.scss';

class ScrollCarouselComponent extends React.Component<IScrollSliderProps> {

	wrapper: React.RefObject<HTMLDivElement> = React.createRef();

	componentDidMount(): void {
		this.scrollToStart();
	}

	componentDidUpdate(prevProps: IScrollSliderProps): void {
		if (prevProps.match.url !== this.props.match.url) {
			this.scrollToStart();
		}
	}

	scrollToStart = () => {
		this.wrapper.current.scrollTo(0, 0);
	};

	render() {
		const {
			className,
			classNameSlides,
			children,
		} = this.props;

		return (
			<div ref={this.wrapper} className={classNames(s.block, className)}>
				<div ref={this.wrapper} className={s.content}>
					{
						React.Children.map(children, (child: React.ReactElement) => {
							return React.cloneElement(
								child,
								{
									className: classNames(s.slide, classNameSlides),
								});
						})
					}
				</div>
			</div>
		);
	}

}

export const ScrollCarousel = withRouter(ScrollCarouselComponent);
